import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from '../reducers';

const persistConfig = {
    key: 'dikooko-root',
    storage,
}
const persistedReducer = persistReducer(persistConfig, rootReducer)
const initialState = {}


export const store = createStore(persistedReducer, initialState, composeWithDevTools(applyMiddleware(thunk)))
export const persistor = persistStore(store)